export default __webpack_public_path__ + "static/media/illustration-algostudy-n-w@2x.c7e0f6f7.png";